var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpeningTimesIconSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.34 0h21.31v24H1.34z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "opening-times-icon-sm_svg__cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".opening-times-icon-sm_svg__s0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Desktop-Homepage-New-Homes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-1",
    clipPath: "url(#opening-times-icon-sm_svg__cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-1",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M13.6.6c0 .7-.5.8-1.2.7v1c5.9.8 10.9 5.1 10.2 12.3-.3 3.2-2 5.4-4.1 7.1.4.8 1.4.9 1.5 2-1 1-1.8-.7-2.5-1.3-2.5 2.1-8.4 2.2-10.9 0-.8.5-1.5 2.3-2.6 1.3.1-1 1-1.3 1.5-1.9C3 19.6 1 16.6 1.4 11.9c.5-5.4 4.9-9 10.2-9.4v-1c-.4-.3-1.1-.1-1.2-.7-.2-1.2 3-.9 3.2-.2zM3.5 11.1c-1.1 4.7 1.7 8.6 4.6 10.1 5.3 2.7 12.7-.9 12.6-8 0-5.5-4.6-9.3-9.8-8.6-3.8.5-6.6 3.1-7.4 6.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-4",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M7.6 1.8c-1 1.4-2.3 2.5-3.5 3.7C3 6.6 2 8 .7 8.7-1.9 4.3 3.2-.7 7.6 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-6",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M23.3 8.7c-1.2-.8-2.4-2.1-3.6-3.2-1.1-1.2-2.3-2.4-3.3-3.7 4.4-2.5 9.4 2.5 6.9 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-8",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M11.7 5.6h.5c.3.3.1.9.2 1.4h-.8c.1-.5-.1-1.1.1-1.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-10",
    clipPath: "url(#opening-times-icon-sm_svg__cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-10",
    className: "opening-times-icon-sm_svg__s0",
    d: "M4.5 13h1.3v.6H4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-12",
    clipPath: "url(#opening-times-icon-sm_svg__cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-12",
    className: "opening-times-icon-sm_svg__s0",
    d: "M18.2 13h1.3v.6h-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-13",
    clipPath: "url(#opening-times-icon-sm_svg__cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-13",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M11.7 13.1c.4-.1.7-.1.5.4-.3 0-.5-.1-.5-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-14",
    clipPath: "url(#opening-times-icon-sm_svg__cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-14",
    className: "opening-times-icon-sm_svg__s0",
    d: "M11.6 19.6h.8v1.2h-.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-15",
    clipPath: "url(#opening-times-icon-sm_svg__cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-15",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M12.2 13.9q-.2 0-.4-.1l-4.9-3.7c-.2-.2-.3-.7-.1-1 .2-.2.7-.3.9-.1l4.9 3.8c.3.2.4.6.2.9-.2.2-.4.2-.6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "opening-times-icon-sm_svg__Clip-Path:_Fill-16",
    clipPath: "url(#opening-times-icon-sm_svg__cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "opening-times-icon-sm_svg__Fill-16",
    fillRule: "evenodd",
    className: "opening-times-icon-sm_svg__s0",
    d: "M12.2 13.9q-.2 0-.4-.2c-.3-.2-.3-.7 0-.9l4.5-4.1c.3-.3.7-.3.9 0 .3.3.3.7 0 1l-4.5 4.1q-.2.1-.5.1z"
  })))))));
}
export default SvgOpeningTimesIconSm;